import React from 'react';
import { connect } from 'react-redux';

import { Props, State } from './flowType';
import {HELP_CENTER} from '../../common/i18n';
import './Style.scss';

class TopHeader extends React.PureComponent<Props, State> {
  constructor (props) {
    super(props);
    const user = localStorage.getItem('user');
    this.state = {
      user: user && JSON.parse(user),
    };
  }

  render () {
    const { user } = this.state;
    const { currentHeader } = this.props;
    return (
      <div
        className="top-header"
      >
        <div className="top-header-pagetitle">
          {currentHeader}
        </div>
        <div className="top-header-right">
          <a
            className="help-center"
            href="https://support.paylode.com/en/"
            target="_blank"
            rel="noopener noreferrer"
          >
            {HELP_CENTER}
          </a>
          <div className="top-header-user">
            <label>{user && user.name}</label>
            <img src={user && user.profile_image && user.profile_image.split('?')[0]} alt="Avatar"></img>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { app } = state;
  const appToJS = app.toJS();
  return {
    currentHeader: appToJS.currentHeader
  };
}

export default connect(mapStateToProps, null)(TopHeader);
